<template>
  <b-modal
    :id="id"
    :hide-header-close="hideHeaderClose"
    :hide-footer="hideDefaultFooter"
    :size="size"
    content-class="p-4"
  >
    <template #modal-title v-if="showTitle">
      <div class="font-weight-bold">{{ title }}</div>
    </template>

    <template #default>
      <slot name="modal-content"></slot>
    </template>

    <template #modal-footer v-if="showFooter">
      <b-button size="sm" variant="outline-primary" @click="onBackClicked">{{ backLabel }}</b-button>
      <b-button size="sm" variant="primary" @click="onConfirmClicked">{{ confirmLabel }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: String,
    title: String,
    confirmLabel: String,
    backLabel: String,
    showTitle: Boolean,
    showFooter: Boolean,
    hideHeaderClose: {
      type: Boolean,
      default: true,
    },
    hideDefaultFooter: Boolean,
    size: {
      type: String,
      default: 'md',
    },
  },
  methods: {
    onBackClicked() {
      this.$emit(`${this.id}-back-clicked`)
    },
    onConfirmClicked() {
      this.$emit(`${this.id}-confirm-clicked`)
    },
  },
}
</script>
